export default "__VITE_ASSET__59358712__$_?nuxt_component=async__"